import React, { useState } from 'react';

/**
 * DeleteAccountPage
 * Provides UI for user PII deletion / account removal per Google Play policy.
 * Users supply their mobile number (identifier) and optional reason; calls /delete-account.
 * NOTE: In production you should authenticate the user session before allowing deletion.
 */
function DeleteAccountPage() {
  const [mobile, setMobile] = useState('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);
    if (!mobile || mobile.trim().length < 6) {
      setError('Enter valid mobile number');
      return;
    }
    try {
      setSubmitting(true);
      const res = await fetch('/delete-account', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobile: mobile.trim(), reason })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed');
      setResult(data.message || 'Deletion request processed');
      setMobile('');
      setReason('');
    } catch (err) {
      setError(err.message || 'Error deleting account');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 520, margin: '0 auto', padding: '24px 16px' }}>
      <h2 style={{ color: '#1a237e', marginBottom: 12 }}>Delete Account & Data</h2>
      <p style={{ fontSize: 14, lineHeight: '20px', color: '#333', marginBottom: 18 }}>
        This will remove your saved addresses and unlink your mobile number. Past orders will be anonymized
        (no personal details) but retained for financial and fraud prevention records. This action cannot be undone.
      </p>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <label style={{ fontSize: 13, fontWeight: 'bold', color: '#0a174e' }}>
          Mobile Number
          <input
            type="text"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter your registered mobile"
            style={{ width: '100%', marginTop: 6, padding: '10px 12px', borderRadius: 8, border: '1px solid #ccc' }}
            disabled={submitting}
            required
          />
        </label>
        <label style={{ fontSize: 13, fontWeight: 'bold', color: '#0a174e' }}>
          Reason (optional)
          <textarea
            value={reason}
            maxLength={500}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Tell us why you are leaving (optional)"
            rows={4}
            style={{ width: '100%', marginTop: 6, padding: '10px 12px', borderRadius: 8, border: '1px solid #ccc', resize: 'vertical' }}
            disabled={submitting}
          />
        </label>
        <div style={{ background: '#fff8e1', padding: '10px 14px', borderRadius: 10, fontSize: 12, color: '#5d4a00' }}>
          By submitting you confirm you are the account owner. This will permanently remove personal data and cannot be reversed.
        </div>
        <button
          type="submit"
          disabled={submitting}
          style={{
            background: submitting ? '#ccc' : '#ed3237',
            color: '#fff',
            padding: '12px 20px',
            border: 'none',
            borderRadius: 10,
            fontWeight: 'bold',
            cursor: submitting ? 'not-allowed' : 'pointer'
          }}
        >
          {submitting ? 'Processing...' : 'Delete My Account'}
        </button>
      </form>
      {error && <div style={{ marginTop: 16, color: '#c62828', fontWeight: 'bold' }}>{error}</div>}
      {result && <div style={{ marginTop: 16, color: '#1b5e20', fontWeight: 'bold' }}>{result}</div>}
      <div className='mt-5 mb-5 pt-5 pb-5'></div>
    </div>
  );
}

export default DeleteAccountPage;